import { render } from "./SceneGui.vue?vue&type=template&id=5506047e"
import script from "./SceneGui.vue?vue&type=script&lang=js"
export * from "./SceneGui.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__